function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("title", null, "ICONS/FIGURES/ico-30-equipementInfo");

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Symbols",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "ICONS/FIGURES/ico-30-equipementInfo"
}, /*#__PURE__*/React.createElement("g", {
  id: "ICONS/\\u2022bg-enjeux",
  transform: "translate(4.000000, 6.000000)",
  fill: "#FFFFFF"
}, /*#__PURE__*/React.createElement("rect", {
  id: "bg-w",
  x: 0,
  y: 0,
  width: 22,
  height: 14
})), /*#__PURE__*/React.createElement("path", {
  d: "M22,23 L23,26 L7,26 L8,23 L22,23 Z M25.5,5 C26.3284271,5 27,5.67157288 27,6.5 L27,19.5 C27,20.3284271 26.3284271,21 25.5,21 L4.5,21 C3.67157288,21 3,20.3284271 3,19.5 L3,6.5 C3,5.67157288 3.67157288,5 4.5,5 L25.5,5 Z M25,7 L5,7 L5,17 L25,17 L25,7 Z",
  id: "Combined-Shape",
  fill: "#D93252"
})));

const SvgIco30EquipementInfo = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "30px",
  height: "30px",
  viewBox: "0 0 30 30",
  ref: svgRef
}, props), title === undefined ? _ref : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIco30EquipementInfo, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ico-30-equipementInfo.59c06abf.svg";
export { ForwardRef as ReactComponent };